const features = [
  {
    icon: 'ri-4k-line',
    title: '高清蓝光画质',
    desc: '全站支持1080P与4K蓝光画质，每一帧都清晰锐利，给你影院级观影享受。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-line',
    title: '流畅不卡顿',
    desc: '全球CDN加速节点覆盖，加载速度快如闪电，追剧过程零等待零缓冲。',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '与电视台同步更新，新剧上线第一时间推送，永远快人一步。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    desc: '电脑、平板、手机全适配，收藏同步，随时随地继续追剧。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净无广告',
    desc: '观影过程无弹窗无插播，沉浸式追剧体验不打折。',
    color: 'bg-accent-100 text-accent-700',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择97影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            五大核心优势，打造极致追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${feat.color} mb-4 md:mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}